import React from 'react'

const Footer = () => {
    const currentYear = new Date().getFullYear(); 

    return (
        <footer className="bg-black">
            <div className="max-w-screen-xl mx-auto px-4 md:px-8 lg:px-16">
                <div className="bg-black h-auto py-4 flex flex-col md:flex-row items-center justify-between text-center md:text-left">
                    {/* Copyright Section */}
                    <div className="text-white text-sm mb-2 md:mb-0">
                        © {currentYear} Gujarati NRI Matrimony. All Rights Reserved.
                    </div>

                    {/* Links Section */}
                    <div className="flex space-x-3 md:space-x-5 text-white text-sm">
                        <a href="/termsandconditions" className="hover:underline">Terms and Conditions</a>
                        <span className="hidden md:block">|</span>
                        <a href="/privacypolicy" className="hover:underline">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer